"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TlvInvalidAccountDataError = exports.TlvError = void 0;
/** Base class for errors */
class TlvError extends Error {
    constructor(message) {
        super(message);
    }
}
exports.TlvError = TlvError;
/** Thrown if the byte length of an tlv buffer doesn't match the expected size */
class TlvInvalidAccountDataError extends TlvError {
    constructor() {
        super(...arguments);
        this.name = 'TlvInvalidAccountDataError';
    }
}
exports.TlvInvalidAccountDataError = TlvInvalidAccountDataError;
//# sourceMappingURL=errors.js.map